import { CriteriaConditionTypeController } from './criteria-condition-type.controller';
import { CriteriaConditionTypeProps } from './criteria-condition-type.model';

export const CriteriaConditionType = (props: CriteriaConditionTypeProps) => {
  return <CriteriaConditionTypeController {...props} />;
};
